<app-header
  [transparent]="false"
  [title]="getTitle()"
  class="test"
  [backRoute]="backRoute()"
></app-header>
@switch (url()) {
  @case ("profile") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <h1>{{ getTitle() }}</h1>
      @if (success()) {
        <div class="toast success">
          <i
            nz-icon
            class="inline-error-icon multicolorIcon"
            nzType="icons:check-circle-filled"
          ></i>
          <span>{{ i18n.langString("changes_successful") }}</span>
        </div>
      }
      @if (error()) {
        <div class="toast error">
          <i
            nz-icon
            class="inline-error-icon fillwhite"
            nzType="icons:error-exclamation-circle"
          ></i>
          <span>{{ i18n.langString("changes_problem") }}</span>
        </div>
      }
      <h2>{{ i18n.langString("personal_information") }}</h2>
      @if (settingsCopyForProfile()) {
        <form>
          <div class="profile-label-group">
            <app-input-label
              [label]="i18n.langString('name')"
              [key]="'firstname'"
              [value]="settingsCopyForProfile()?.name ?? ''"
              (onchange)="onNameChange($event)"
            >
            </app-input-label>

            <app-input-label
              [label]="i18n.langString('surname')"
              [key]="'lastname'"
              [value]="settingsCopyForProfile()?.surname ?? ''"
              (onchange)="onSurnameChange($event)"
            >
            </app-input-label>
            <app-input-label
              [label]="i18n.langString('designation')"
              [key]="'designation'"
              [value]="settingsCopyForProfile()?.designation ?? ''"
              [optional]="true"
              (onchange)="onDesignationChange($event)"
            >
            </app-input-label>
          </div>
          <app-nav-button
            class="user-profile-submit"
            [primary]="true"
            svgIcon="icons:save"
            (clickEvent)="onSubmitProfileChanges()"
            [disabled]="!(containName && containSurname)"
          >
            {{ i18n.langString("apply_changes") }}
          </app-nav-button>
        </form>
      }
      @if (loading()) {
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      }
    </div>
  }
  @case ("change-password") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <app-change-password></app-change-password>
    </div>
  }
  @case ("metric") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <h1>{{ getTitle() }}</h1>
      @if (success()) {
        <div class="toast success">
          <i
            nz-icon
            class="inline-error-icon multicolorIcon"
            nzType="icons:check-circle-filled"
          ></i>
          <span>{{ i18n.langString("changes_successful") }}</span>
        </div>
      }
      @if (error()) {
        <div class="toast error">
          <i
            nz-icon
            class="inline-error-icon fillwhite"
            nzType="icons:error-exclamation-circle"
          ></i>
          <span>{{ i18n.langString("changes_problem") }}</span>
        </div>
      }
      @if (!loading() && settings(); as currentSettings) {
        <h2>{{ i18n.langString("system_of_measurement") }}</h2>

        <nz-radio-group [(ngModel)]="currentSettings.measurementSystemID">
          @for (ms of currentSettings.measurementSystems; track ms.id) {
            <label
              class="body-bold"
              (click)="ms.id && handleMeasurementSystemChange(ms.id)"
              nz-radio
              [nzValue]="ms.id"
              >{{ i18n.parse(ms.name) }}</label
            >
          }
        </nz-radio-group>

        <h2>{{ i18n.langString("date_format") }}</h2>
        <nz-radio-group [(ngModel)]="currentSettings.dateFormatID">
          @for (df of currentSettings.dateFormats; track df.id) {
            <label
              (click)="df.id && handleDateFormatChange(df.id)"
              nz-radio
              [nzValue]="df.id"
              class="body-bold"
              >{{ i18n.parse(df.name) }}</label
            >
          }
        </nz-radio-group>
      }
    </div>
  }
  @case ("technical_documents") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <h1>{{ getTitle() }}</h1>

      <app-technical-documents-subpage [page]="firstParameter()">
      </app-technical-documents-subpage>
    </div>
  }
  @case ("notifications") {
    @if (cfg.appName === "em") {
      <div class="content desktop-slim" [class.desktop]="!isMobile()">
        <app-all-notifications-settings
          [settings]="settings()"
          (updateSettings)="handleSettingsChange($event)"
          [success]="success()"
          [loading]="loading()"
        />

        <app-notifications-settings-subpage
          [settings]="settings()"
          [error]="error()"
          (updateSettings)="handleSettingsChange($event)"
          [success]="success()"
          [loading]="loading()"
        />
      </div>
    }
  }
  @case ("language") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <h1>{{ getTitle() }}</h1>

      @if (success()) {
        <div class="toast success">
          <i
            nz-icon
            class="inline-error-icon multicolorIcon"
            nzType="icons:check-circle-filled"
          ></i>
          <span>{{ i18n.langString("changes_successful") }}</span>
        </div>
      }
      @if (error()) {
        <div class="toast error">
          <i
            nz-icon
            class="inline-error-icon fillwhite"
            nzType="icons:error-exclamation-circle"
          ></i>
          <span>{{ i18n.langString("changes_problem") }}</span>
        </div>
      }
      @if (!loading() && settings(); as currentSettings) {
        <nz-radio-group [(ngModel)]="currentSettings.languageID">
          @for (language of currentSettings.languages; track language.id) {
            <div class="radio-input-wrapper">
              <label
                (click)="language.id && handleLanguageChange(language.id)"
                class="body-bold"
                nz-radio
                [nzValue]="language.id"
              >
                {{ language.name }}
              </label>
            </div>
          }
        </nz-radio-group>
      }
    </div>
  }
  @case ("help") {
    <div class="content desktop-medium" [class.desktop]="!isMobile()">
      <h1>{{ getTitle() }}</h1>
      <div class="more-info-subgroup terms-subgroup helpfaq-subgroup">
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          [svgIcon]="'icons:sensor'"
          [svgIconRight]="'icons:arrow-right'"
          (click)="toAboutPage()"
          >{{ i18n.langString("about_loctite") }}
        </app-more-info>
        @if (false) {
          <app-more-info
            [variant]="'more-info-flat'"
            [grouped]="true"
            [svgIcon]="'icons:help-round'"
            [svgIconRight]="'icons:arrow-right'"
            (click)="toSubpage('help/faq')"
            >{{ i18n.langString("faq") }}
          </app-more-info>
        }
      </div>
      <h2>{{ i18n.langString("your_contact") }}</h2>
      <div class="contact-outer-wrapper-flex">
        <img
          nz-image
          nzDisablePreview
          class="employee-img"
          nzSrc="/assets/images/support.jpg"
          alt="Employee"
          nzFallback="assets\images\support.jpg"
        />
        <div class="contact-wrapper-flex">
          <div class="button-wrapper-contact">
            <app-nav-button
              [primary]="true"
              svgIcon="icons:mail"
              mailto="service@loctite-pulse.com"
            >
              {{ i18n.langString("loctite_support_mail") }}
            </app-nav-button>
          </div>

          @if (false) {
            <div class="button-wrapper-contact">
              <app-nav-button
                [primary]="true"
                svgIcon="icons:phone"
                phone="+49893208001600"
              >
                +49 89 320 800 1600
              </app-nav-button>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @case ("terms") {
    <div class="content desktop-slim" [class.desktop]="!isMobile()">
      <div class="more-info-subgroup terms-subgroup">
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          [svgIconRight]="'icons: arrow-right'"
          (click)="toTermsOfService()"
          >{{ i18n.langString("terms_of_service") }}
        </app-more-info>

        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:privacy"
          [svgIconRight]="'icons: arrow-right'"
          (click)="toSubpage('terms/privacypolicy')"
          >{{ i18n.langString("privacy_policy") }}
        </app-more-info>

        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:imprint"
          [svgIconRight]="'icons: arrow-right'"
          (click)="toImprint()"
          >{{ i18n.langString("imprint2") }}</app-more-info
        >
      </div>
    </div>
  }
  @case ("imprint") {
    <div
      class="content content-more-margin-view desktop-wide"
      [class.desktop]="!isMobile()"
    >
      <app-imprint></app-imprint>
    </div>
  }
  @case ("data-protection") {
    <div
      class="content content-more-margin-view desktop-wide"
      [class.desktop]="!isMobile()"
    >
      <app-data-protection></app-data-protection>
    </div>
  }
  @case ("service-conditions") {
    <div
      class="content content-more-margin-view desktop-wide"
      [class.desktop]="!isMobile()"
    >
      <app-service-conditions></app-service-conditions>
    </div>
  }
  @case ("terms-of-use") {
    <div
      class="content content-more-margin-view desktop-wide"
      [class.desktop]="!isMobile()"
    >
      <app-terms-of-use></app-terms-of-use>
    </div>
  }
  @case ("note-for-us-residents") {
    <div
      class="content content-more-margin-view desktop-wide"
      [class.desktop]="!isMobile()"
    >
      <app-note-for-us-residents></app-note-for-us-residents>
    </div>
  }
}
